// extracted by mini-css-extract-plugin
module.exports = {"select":"select__1OVSV","open":"open__7X8hH"};